import { Component, Input, signal } from '@angular/core';
import { MatSidenav } from '@angular/material/sidenav';
import { MatListModule } from '@angular/material/list';
import { MatExpansionModule } from '@angular/material/expansion';
import { MatIconModule } from '@angular/material/icon';
import { RouterLink, RouterLinkActive } from '@angular/router';
import { NavigationItem } from '../../../models/navigation-item.model';
import { DEFAULT_VERSION, QA_CYCLE } from '../../../constants/version';
import { environment } from '../../../../environments/environment';

@Component({
  selector: 'app-menu-drawer',
  standalone: true,
  imports: [MatListModule, MatExpansionModule, MatIconModule, RouterLink, RouterLinkActive],
  templateUrl: './menu-drawer.component.html',
  styleUrls: ['./menu-drawer.component.scss']
})
export class MenuDrawerComponent {
  @Input() drawerRef!: MatSidenav;
  @Input() set routesData(value: NavigationItem[]) {
    this._routesData.set(value);
  }

  private _routesData = signal<NavigationItem[]>([]);
  version: string = DEFAULT_VERSION + (environment.production ? '' : QA_CYCLE);

  get routesData(): NavigationItem[] {
    return this._routesData();
  }

  toggleDrawer(): void {
    this.drawerRef.toggle();
  }

  isSingleRoute(route: NavigationItem): boolean {
    return !route?.children || route.children.length === 0;
  }

  isGroupedRoute(route: NavigationItem): boolean {
    if (route?.children && route.children.length > 0) {
      return !this.isMultiGroupedRoute(route);
    }
    return false;
  }

  isMultiGroupedRoute(route: NavigationItem): boolean {
    if (route?.children && route.children.length > 0) {
      const innerChild = route.children.filter((r) => r.children && r.children.length > 0);
      return innerChild.length > 0;
    }
    return false;
  }
}
